import Env from "../base/env";
import Channels from "../base/channels";
import Component from "gia/Component";
import gsap from "gsap";
import Splide from "@splidejs/splide";
import { RevealFade } from "../fx/Common";
import CursorFollow from "../fx/CursorFollow";

export default class Features extends Component {
  mount() {
    //? DOM
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.slideshow = this.element.querySelector(".jsSlideshow");
    this.DOM.landmark =
      this.DOM.slideshow.parentElement.querySelector(".js-landmark");
    //? Vars
    this.VARS = {};
    //? Fns
    this.cursor = new CursorFollow(this.DOM.view);
    this.makeSlideshow();
    setTimeout(() => {
      RevealFade(this.DOM.view);
    }, Env.timingDelayFx);
    this.funcResize = this.resize.bind(this);
    Channels.on("window::smartresize", this.funcResize);
  }

  makeSlideshow() {
    this.slideshow = new Splide(this.DOM.slideshow, {
      arrows: false,
      gap: 40,
      interval: 7000,
      padding: {
        left: this.DOM.landmark.getBoundingClientRect().x,
        right: this.DOM.landmark.getBoundingClientRect().x,
      },
      pauseOnFocus: false,
      pauseOnHover: false,
      pagination: true,
      perPage: 2,
      perMove: 1,
      // autoWidth: true,
      // heightRatio: 0.5,
      autoHeight: true,
      // fixedHeight: "40vh",
      rewind: true,
      rewindByDrag: true,
      speed: 700,
      type: "slide",
      breakpoints: {
        640: {
          arrows: false,
          pagination: true,
          fixedWidth: "83%",
          gap: 24,
          padding: { left: 32, right: 32 },
          perPage: 1,
        },
      },
    }).mount();
  }

  resize() {
    this.slideshow.destroy();
    this.makeSlideshow();
  }

  unmount() {
    this.cursor.destroy();
    this.slideshow.destroy(true);
    Channels.removeListener("window::smartresize", this.funcResize);
  }
}
